<template>
  <div class="checkout">
    <v-container style="padding-top: 70px; min-height: calc(100vh - 350px);" class="pb-8">
      <v-row align="center">
        <v-col cols="12">
          <v-breadcrumbs :items="items" divider="|" class="px-0"></v-breadcrumbs>
        </v-col>
      </v-row>

      <v-row align="center" class="mb-8 d-none d-sm-flex">
        <v-spacer></v-spacer>
        <v-col class="text-center" cols="auto">
          <span class="d-inline-block titulo verde-oscuro" style="width: 250px">1. SESIÓN</span>
        </v-col>
        <v-spacer>
          <hr />
        </v-spacer>
        <v-spacer>
          <hr />
        </v-spacer>
        <v-col class="text-center" cols="auto">
          <span class="d-inline-block titulo gris" style="width: 250px">2. DATOS DE ENVIO</span>
        </v-col>
        <v-spacer>
          <hr />
        </v-spacer>
        <v-spacer>
          <hr />
        </v-spacer>
        <v-col class="text-center" cols="auto">
          <span class="d-inline-block titulo gris" style="width: 250px">3. TIPO DE PAGO</span>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <v-row class="d-sm-none" align="center">
        <v-col class="text-center" cols="auto">
          <v-avatar color="#03241D">
            <span class="white--text">1</span>
          </v-avatar>
        </v-col>
        <v-spacer>
          <hr />
        </v-spacer>

        <v-col cols="auto" class="text-center">
          <v-avatar color="#D8D8D8">2</v-avatar>
        </v-col>
        <v-spacer>
          <hr />
        </v-spacer>
        <v-col cols="auto" class="text-center">
          <v-avatar color="#D8D8D8">3</v-avatar>
        </v-col>
      </v-row>

      <div class="animated fadeIn">
        <v-row justify="center">
          <v-col cols="12" md="6" lg="4" xl="3" class="text-center">
            <v-form>
              <span class="titulo uppercase">Inicia sesión</span>

              <v-text-field
                type="email"
                v-model="login.email"
                label="CORREO ELECTRÓNICO"
                color="#979797"
              ></v-text-field>

              <v-text-field
                type="password"
                v-model="login.password"
                label="CONTRASEÑA"
                color="#979797"
              ></v-text-field>

              <v-btn elevation="0" color="#064434" tile :ripple="false" block @click="login_fnc()">
                <span class="subtitulo blanco">acceder</span>
              </v-btn>

              <v-btn text color="transparent">
                <span
                  class="modernist-bold"
                  style="font-size: 10px; color: #979797"
                >REESTABLECER CONTRASEÑA</span>
              </v-btn>
            </v-form>
          </v-col>
        </v-row>

        <v-row class="mt-12" justify="center">
            <v-col cols="3" class="text-center">

                <span class="modernist-bold" style="font-size: 12px;">
                    ¿NUEVO EN CHLOROPHILIA?
                </span>

                <router-link to="/CheckoutRegalo/registro" class="d-block mt-3">
                    <v-btn elevation="0" color="#064434" tile :ripple="false" block>
                        <span class="subtitulo blanco">
                            REGÍSTRARSE
                        </span>
                    </v-btn>
                </router-link>
            </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    items: [
      {
        text: "Inicio",
        disabled: false,
        to: "/"
      },
      {
        text: "Cesta de Compra",
        disabled: false,
        to: "/cart"
      },
      {
        text: "Tramitar pedido",
        disabled: true
      },
      {
        text: "1. Sesión",
        disabled: true
      }
    ],
    paso: 1, // Paso general (1 -> Sesión, 2 -> Datos de envio, 3 -> Tipo de pago)
    paso_sesion: 0, // Paso referente a la sesión (0 -> sin seleccion, 1 -> iniciar sesión, 2 -> registrate),
    login: {
      email: "",
      password: ""
    },
    personal: {
      email: "",
      confirmacion: "",
      nombre: "",
      telefono: "",
      factura: false
    },
    envio: {
      direccion: "",
      direccion_extra: "",
      codigo_postal: "",
      municipio: "",
      ciudad: "",
      colonia: "",
      estado: "",
      pais: "México"
    }
  }),
  methods: {
    login_fnc: function() {
      axios
        .post("https://strapi.actstudio.xyz/auth/local", {
          identifier: this.login.email,
          password: this.login.password
        })
        .then(response => {
          // Handle success.
          console.log("Well done!");
          // console.log('User profile', response.data.user);
          // console.log('User token', response.data.jwt);
          console.log(response.data);
          this.$session.set("user", response.data);
          this.$router.push("/CheckoutRegalo/envio");
        })
        .catch(error => {
          // Handle error.
          console.log("An error occurred:", error);
        });
    }
  },
  mounted: function() {
    //emitir evento para ocultarc menú
    this.$emit("updateMenu", 1);
    gtag('config', 'UA-163902944-1', {
      'page_title' : 'Iniciar sesión en checkout de regalo',
      'page_path': '/CheckoutRegalo/login'
    });
  }
};
</script>